"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Keplr = void 0;
const router_1 = require("@keplr-wallet/router");
const enigma_1 = require("./enigma");
const cosmjs_1 = require("./cosmjs");
const deepmerge_1 = __importDefault(require("deepmerge"));
const long_1 = __importDefault(require("long"));
const buffer_1 = require("buffer/");
class Keplr {
    constructor(version, mode, requester) {
        this.version = version;
        this.mode = mode;
        this.requester = requester;
        this.enigmaUtils = new Map();
        this.defaultOptions = {};
    }
    enable(chainIds) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof chainIds === "string") {
                chainIds = [chainIds];
            }
            yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "permission-interactive", "enable-access", {
                chainIds,
            });
        });
    }
    disable(chainIds) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof chainIds === "string") {
                chainIds = [chainIds];
            }
            yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "permission-interactive", "disable-access", {
                chainIds: chainIds !== null && chainIds !== void 0 ? chainIds : [],
            });
        });
    }
    experimentalSuggestChain(chainInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            if (chainInfo.hideInUI) {
                throw new Error("hideInUI is not allowed");
            }
            if (chainInfo.gasPriceStep) {
                // Gas price step in ChainInfo is legacy format.
                // Try to change the recent format for backward-compatibility.
                const gasPriceStep = Object.assign({}, chainInfo.gasPriceStep);
                for (const feeCurrency of chainInfo.feeCurrencies) {
                    if (!feeCurrency.gasPriceStep) {
                        feeCurrency.gasPriceStep = gasPriceStep;
                    }
                }
                delete chainInfo.gasPriceStep;
                console.warn("The `gasPriceStep` field of the `ChainInfo` has been moved under `feeCurrencies`. This is automatically handled as of right now, but the upcoming update would potentially cause errors.");
            }
            if (chainInfo.coinType) {
                console.warn("The `coinType` field of the `ChainInfo` is removed. This is automatically handled as of right now, but the upcoming update would potentially cause errors.");
                delete chainInfo.coinType;
            }
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "chains", "suggest-chain-info", {
                chainInfo,
            });
        });
    }
    getKey(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-cosmos", "get-cosmos-key", {
                chainId,
            });
        });
    }
    getKeysSettled(chainIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-cosmos", "get-cosmos-keys-settled", {
                chainIds,
            });
        });
    }
    getChainInfosWithoutEndpoints() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "chains", "get-chain-infos-without-endpoints", {})).chainInfos;
        });
    }
    sendTx(chainId, tx, mode) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "background-tx", "send-tx-to-background", {
                chainId,
                tx,
                mode,
            });
        });
    }
    signAmino(chainId, signer, signDoc, signOptions = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-cosmos", "request-cosmos-sign-amino", {
                chainId,
                signer,
                signDoc,
                signOptions: (0, deepmerge_1.default)((_a = this.defaultOptions.sign) !== null && _a !== void 0 ? _a : {}, signOptions),
            });
        });
    }
    signDirect(chainId, signer, signDoc, signOptions = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-cosmos", "request-cosmos-sign-direct", {
                chainId,
                signer,
                signDoc: {
                    bodyBytes: signDoc.bodyBytes,
                    authInfoBytes: signDoc.authInfoBytes,
                    chainId: signDoc.chainId,
                    accountNumber: signDoc.accountNumber
                        ? signDoc.accountNumber.toString()
                        : null,
                },
                signOptions: (0, deepmerge_1.default)((_a = this.defaultOptions.sign) !== null && _a !== void 0 ? _a : {}, signOptions),
            });
            return {
                signed: {
                    bodyBytes: response.signed.bodyBytes,
                    authInfoBytes: response.signed.authInfoBytes,
                    chainId: response.signed.chainId,
                    accountNumber: long_1.default.fromString(response.signed.accountNumber),
                },
                signature: response.signature,
            };
        });
    }
    signDirectAux(chainId, signer, signDoc, signOptions = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-cosmos", "request-cosmos-sign-direct-aux", {
                chainId,
                signer,
                signDoc: {
                    bodyBytes: signDoc.bodyBytes,
                    publicKey: signDoc.publicKey,
                    chainId: signDoc.chainId,
                    accountNumber: signDoc.accountNumber
                        ? signDoc.accountNumber.toString()
                        : null,
                    sequence: signDoc.sequence ? signDoc.sequence.toString() : null,
                },
                signOptions: (0, deepmerge_1.default)({
                    preferNoSetMemo: (_a = this.defaultOptions.sign) === null || _a === void 0 ? void 0 : _a.preferNoSetMemo,
                }, signOptions),
            });
            return {
                signed: {
                    bodyBytes: response.signed.bodyBytes,
                    publicKey: response.signed.publicKey,
                    chainId: response.signed.chainId,
                    accountNumber: long_1.default.fromString(response.signed.accountNumber),
                    sequence: long_1.default.fromString(response.signed.sequence),
                },
                signature: response.signature,
            };
        });
    }
    signArbitrary(chainId, signer, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-cosmos", "request-cosmos-sign-amino-adr-36", {
                chainId,
                signer,
                data: typeof data === "string" ? buffer_1.Buffer.from(data) : data,
                signOptions: {
                    isADR36WithString: typeof data === "string",
                },
            });
        });
    }
    verifyArbitrary(chainId, signer, data, signature) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof data === "string") {
                data = buffer_1.Buffer.from(data);
            }
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-cosmos", "verify-cosmos-sign-amino-adr-36", {
                chainId,
                signer,
                data,
                signature,
            });
        });
    }
    signEthereum(chainId, signer, message, signType) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-ethereum", "request-sign-ethereum", {
                chainId,
                signer,
                message: typeof message === "string" ? buffer_1.Buffer.from(message) : message,
                signType,
            });
        });
    }
    signICNSAdr36(chainId, contractAddress, owner, username, addressChainIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-cosmos", "request-icns-adr-36-signatures-v2", {
                chainId,
                contractAddress,
                owner,
                username,
                addressChainIds,
            });
        });
    }
    getOfflineSigner(chainId, signOptions) {
        return new cosmjs_1.CosmJSOfflineSigner(chainId, this, signOptions);
    }
    getOfflineSignerOnlyAmino(chainId, signOptions) {
        return new cosmjs_1.CosmJSOfflineSignerOnlyAmino(chainId, this, signOptions);
    }
    getOfflineSignerAuto(chainId, signOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = yield this.getKey(chainId);
            if (key.isNanoLedger) {
                return new cosmjs_1.CosmJSOfflineSignerOnlyAmino(chainId, this, signOptions);
            }
            return new cosmjs_1.CosmJSOfflineSigner(chainId, this, signOptions);
        });
    }
    suggestToken(chainId, contractAddress, viewingKey) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "token-cw20", "SuggestTokenMsg", {
                chainId,
                contractAddress,
                viewingKey,
            });
        });
    }
    getSecret20ViewingKey(chainId, contractAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "token-cw20", "get-secret20-viewing-key", {
                chainId,
                contractAddress,
            });
        });
    }
    getEnigmaPubKey(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "secret-wasm", "get-pubkey-msg", {
                chainId,
            });
        });
    }
    getEnigmaTxEncryptionKey(chainId, nonce) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "secret-wasm", "get-tx-encryption-key-msg", {
                chainId,
                nonce,
            });
        });
    }
    enigmaEncrypt(chainId, contractCodeHash, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    msg) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "secret-wasm", "request-encrypt-msg", {
                chainId,
                contractCodeHash,
                msg,
            });
        });
    }
    enigmaDecrypt(chainId, cipherText, nonce) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!cipherText || cipherText.length === 0) {
                return new Uint8Array();
            }
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "secret-wasm", "request-decrypt-msg", {
                chainId,
                cipherText,
                nonce,
            });
        });
    }
    getEnigmaUtils(chainId) {
        if (this.enigmaUtils.has(chainId)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return this.enigmaUtils.get(chainId);
        }
        const enigmaUtils = new enigma_1.KeplrEnigmaUtils(chainId, this);
        this.enigmaUtils.set(chainId, enigmaUtils);
        return enigmaUtils;
    }
    experimentalSignEIP712CosmosTx_v0(chainId, signer, eip712, signDoc, signOptions = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-cosmos", "request-sign-eip-712-cosmos-tx-v0", {
                chainId,
                signer,
                eip712,
                signDoc,
                signOptions: (0, deepmerge_1.default)((_a = this.defaultOptions.sign) !== null && _a !== void 0 ? _a : {}, signOptions),
            });
        });
    }
    __core__getAnalyticsId() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "analytics", "get-analytics-id", {});
        });
    }
    changeKeyRingName({ defaultName, editable = true, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-v2", "change-keyring-name-interactive", {
                defaultName,
                editable,
            });
        });
    }
    __core__privilageSignAminoWithdrawRewards(chainId, signer, signDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-cosmos", "PrivilegeCosmosSignAminoWithdrawRewards", {
                chainId,
                signer,
                signDoc,
            });
        });
    }
    __core__privilageSignAminoDelegate(chainId, signer, signDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "keyring-cosmos", "PrivilegeCosmosSignAminoDelegate", {
                chainId,
                signer,
                signDoc,
            });
        });
    }
    sendEthereumTx(chainId, tx) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "background-tx-ethereum", "send-ethereum-tx-to-background", {
                chainId,
                tx,
            });
        });
    }
    suggestERC20(chainId, contractAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, router_1.sendSimpleMessage)(this.requester, router_1.BACKGROUND_PORT, "token-erc20", "SuggestERC20TokenMsg", {
                chainId,
                contractAddress,
            });
        });
    }
}
exports.Keplr = Keplr;
//# sourceMappingURL=core.js.map